export const GenieAcsSkeletonRowComponent = ({ cols = 8 }) => (
    <tr className="animate-pulse">
        {Array.from({ length: cols }).map((_, i) => (
            <td key={i} className="px-4 py-3">
                <div
                    className="h-3.5 bg-slate-700/60 rounded-md"
                    style={{ width: `${40 + Math.random() * 50}%` }}
                />
            </td>
        ))}
    </tr>
);